import React from 'react';
import Marquee from 'react-fast-marquee';
import styled from 'styled-components';
import {press} from '../data/press';

const PressLink = styled.a`
	width: max-content;
	margin: 30px 20px;
	vertical-align: middle;
`;

const PressName = styled.h4`
	width: max-content;
	margin: 15px 20px;
	color: #deded0;
    transition: 300ms ease-in-out;

    &:hover {
        color: #b5b59b;
    }
`;

const PressLinks = () => {
	return (
		<section>
			<div className="container container--md">
				<Marquee speed="25" direction="left" pauseOnHover="true">
					{press.map((item, index) => (
						<PressLink key={index} href={item.article} target="_blank" rel="noopener noreferrer">
							<PressName>{item.name}</PressName>
						</PressLink>
					))}
				</Marquee>
			</div>
		</section>
	);
};

export default PressLinks;
